export default "__VITE_ASSET__b8dddf52__"